import * as React from "react";
import { Slider } from "@teliaee/react-slick";
import { Button } from "../button/button.mjs";
import { Image } from "../image/image.mjs";
import { Placeholder } from "./placeholder.mjs";
import { usePlaceholderArray, useSliderSettings } from "./utils.mjs";
const Pager = (props) => {
  const { afterChange, asNavFor, items, nextArrowText, prevArrowText, placeholder, sliderRef, onItemClick, onNextButtonClick, onPrevButtonClick } = props;
  const placeholders = usePlaceholderArray(items.length);
  const sliderSettings = useSliderSettings(items.length + placeholders.length, {
    arrows: true,
    asNavFor: asNavFor || void 0,
    nextArrow: /* @__PURE__ */ React.createElement(NextButton, { text: nextArrowText, clickCallback: onNextButtonClick }),
    prevArrow: /* @__PURE__ */ React.createElement(PrevButton, { text: prevArrowText, clickCallback: onPrevButtonClick }),
    swipe: false,
    variableWidth: true,
    afterChange
  });
  return /* @__PURE__ */ React.createElement("div", { className: BEM(items.length + placeholders.length) }, /* @__PURE__ */ React.createElement(Slider, { className: "product-comparison__pager-slider", ...sliderSettings, ref: sliderRef }, items.map((item, index) => {
    const { image } = item;
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "product-comparison__pager-item",
        key: index,
        tabIndex: -1,
        onClick: (event) => {
          event.preventDefault();
          onItemClick == null ? void 0 : onItemClick(index);
        }
      },
      /* @__PURE__ */ React.createElement(Image, { ...image, className: "product-comparison__pager-item-image" })
    );
  }), placeholders.map((_i, index) => {
    return /* @__PURE__ */ React.createElement("div", { className: "product-comparison__pager-item", key: "placeholder-".concat(index) }, index === 0 && /* @__PURE__ */ React.createElement(Placeholder, { ...placeholder }));
  })));
};
const BEM = (itemCount) => {
  const classArray = ["product-comparison__pager"];
  if (itemCount) {
    classArray.push("product-comparison__pager--".concat(itemCount));
  }
  return classArray.join(" ");
};
const NextButton = (props) => {
  var _a;
  const isDisabled = (_a = props.className) == null ? void 0 : _a.includes("slick-disabled");
  const clickHandler = (event) => {
    event.preventDefault();
    if (props.clickCallback) {
      props.clickCallback();
    }
    if (props.onClick) {
      props.onClick(event);
    }
  };
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      ...props,
      onClick: clickHandler,
      disabled: isDisabled,
      variant: "secondary",
      size: "small",
      icon: "#arrow-right",
      className: "".concat(props.className, " product-comparison__nav product-comparison__nav--next"),
      attributes: { tabIndex: -1 }
    }
  );
};
const PrevButton = (props) => {
  var _a;
  const isDisabled = (_a = props.className) == null ? void 0 : _a.includes("slick-disabled");
  const clickHandler = (event) => {
    event.preventDefault();
    if (props.clickCallback) {
      props.clickCallback();
    }
    if (props.onClick) {
      props.onClick(event);
    }
  };
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      ...props,
      onClick: clickHandler,
      disabled: isDisabled,
      variant: "secondary",
      size: "small",
      icon: "#arrow-left",
      className: "".concat(props.className, " product-comparison__nav product-comparison__nav--prev"),
      attributes: { tabIndex: -1 }
    }
  );
};
export {
  Pager
};
